module.exports = __webpack_public_path__ + "img/7.c8813ca2.jpg";